import React, { useState,useEffect } from "react";
import "./Trendy.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { fetchHomeProducts } from "../../../Features/Home/home_slice";
import FavoriteButton from "../../Favourite_button/favourite_button";
import CircleLoading from "../../CirculusIndicator/CircleLoading";
const Trendy = () => {
  const dispatch = useDispatch();
  const { allProducts, newArrivals, topRated, status } = useSelector((state) => state.home);
  const [activeTab, setActiveTab] = useState("tab1");
  
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchHomeProducts());
    }
  }, [dispatch, status]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderProducts = (products) => (
    <div className="trendyMainContainer">
      {products.map((product) => (
        <div className="trendyProductContainer" key={product.id}>
          <div className="trendyProductImages">
             <Link to={`/product/${product.productId}`} state={{ product }} onClick={scrollToTop}>
              <img src={product.images[0]} alt="" className="trendyProduct_front" />
              <img src={product.images[1]} alt="" className="trendyProduct_back" />
            </Link>
          </div>
          <div className="trendyProductInfo">
            <div className="trendyProductCategoryWishlist">
              <p>{product.category}</p>
              <FavoriteButton productId={product.productId} />
            </div>
            <div className="trendyProductNameInfo">
              <Link to={`/product/${product.productId}`} state={{ product }} onClick={scrollToTop}>
                <h5>{product.title}</h5>
              </Link>
              <p>
                {product.hasDiscount ? (
                  <>
                    <span style={{ textDecoration: "line-through", color: "gray", marginRight: "5px" }}>
                      Rs.{product.price}
                    </span>
                    <span style={{ color: "black" }}>Rs.{product.discountPrice}</span>
                  </>
                ) : (
                  <span>Rs.{product.price}</span>
                )}
              </p>
              <div className="trendyProductRatingReviews">
                <div className="trendyProductRatingStar">
                  {Array.from({ length: 5 }).map((_, index) => {
                    const rating = product.totalRating / product.totalPeopleReview || 0;
                    const fullStars = Math.floor(rating);
                    const hasHalfStar = rating - fullStars >= 0.5;
                    if (index < fullStars) return <FaStar key={index} color="#FEC78A" size={14} />;
                    else if (index === fullStars && hasHalfStar) return <FaStarHalfAlt key={index} color="#FEC78A" size={14} />;
                    else return <FaRegStar key={index} color="#FEC78A" size={14} />;
                  })}
                </div>
                <span>{product.totalPeopleReview}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );



  return (
    <>
      <div className="trendyProducts">
        <h2>
          Our Trendy <span>Products</span>
        </h2>
        <div className="trendyTabs">
          <div className="tabs">
          <p onClick={() => handleTabClick("tab1")} className={activeTab === "tab1" ? "active" : ""}>All</p>
          <p onClick={() => handleTabClick("tab2")} className={activeTab === "tab2" ? "active" : ""}>New Arrivals</p>
          <p onClick={() => handleTabClick("tab3")} className={activeTab === "tab3" ? "active" : ""}>Top Rated</p>
          </div>
          <div className="trendyTabContent">
          {status === "loading" ? <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            ><CircleLoading /></div>  : activeTab === "tab1" ? renderProducts(allProducts) : activeTab === "tab2" ? renderProducts(newArrivals) : renderProducts(topRated)}
          
          </div>
        </div>
        <div className="discoverMore">
          <Link to="/shop" onClick={scrollToTop}>
            <p>Discover More</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Trendy;
